module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages"
  }, [_c('sub-ibox-title', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("自动回复管理")])]), _vm._v(" "), _c('z-tab-bar', {
    attrs: {
      "list-obj": _vm.tabBarParams.list,
      "active": _vm.tabBarParams.active
    },
    on: {
      "handleClickTabBar": _vm.handleClickTabBar
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('z-radio-material', {
    attrs: {
      "radio-bar-params": _vm.radioBarParams,
      "is-layer-material": _vm.isLayerMaterial
    },
    on: {
      "cancelMaterialLayer": _vm.cancelMaterialLayer,
      "handleClickRadioBar": _vm.handleClickRadioBar,
      "handleSetContent": _vm.handleSetContent
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabBarParams.active == 'autoreply'),
      expression: "tabBarParams.active =='autoreply'"
    }],
    staticClass: "p-t-10 tips"
  }, [_c('p', [_vm._v("Tips：设置了自动回复,则自动应答机器人关闭,反之则开启。")])]), _vm._v(" "), _c('div', {
    staticClass: "m-t-20"
  }, [_c('a', {
    staticClass: "z-btn z-btn-primary b-r-3",
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("保存")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-0a26e66e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/wechat/WxReply.vue
// module id = 811
// module chunks = 0